module.exports = __webpack_public_path__ + "img/update.55e3f01e.jpg";